import { render, staticRenderFns } from "./MobileDeviceRegistrySettings.vue?vue&type=template&id=b653f1c8&scoped=true&"
import script from "./MobileDeviceRegistrySettings.vue?vue&type=script&lang=js&"
export * from "./MobileDeviceRegistrySettings.vue?vue&type=script&lang=js&"
import style0 from "./MobileDeviceRegistrySettings.vue?vue&type=style&index=0&id=b653f1c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b653f1c8",
  null
  
)

export default component.exports